<template>
	<div
		style="height: 100vh"
		class="d-flex justify-center align-center"
		v-if="loading">
		<Loader></Loader>
	</div>

	<!-- <div
		v-else
		class="fill-hight d-flex align-center"
		style="height: calc(100vh - 50px)"
		fluid
	>
		<div class="header-image">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 375 65.97"
				style="
					shape-rendering: geometricPrecision;
					text-rendering: geometricPrecision;
					image-rendering: optimizeQuality;
					fill-rule: evenodd;
					clip-rule: evenodd;
				"
				xmlns:xlink="http://www.w3.org/1999/xlink">
				<g>
					<path d="M0,0H375S233.21,67.86,117.9,65.93,0,0,0,0Z" />
				</g>
			</svg>
		</div> -->
	<div v-else class="page-container mx-auto px-2">
		<div style="z-index: 4; position: relative">
			<template v-if="false">
				<!-- logo -->
				<v-card
					:to="{ name: 'about' }"
					class="d-inline-block rounded-circle"
				>
					<v-card-text class="pa-2">
						<v-img
							src="@/assets/Logo.png"
							height="5.5rem"
							max-width="5.5rem"
							alt="logo"
							contain
						/>
					</v-card-text>
				</v-card>
				<div class="d-flex justify-space-between align-center mb-4">
					<div class="d-flex flex-column">
						<!-- logout -->
						<v-btn
							text
							:height="config.useCourses ? 26 : null"
							:small="config.useCourses"
							class="font-weight-regular"
							:class="{ 'justify-start': config.useCourses }"
							@click="loginMenu = !$isOffline.value"
						>
							<v-icon left> mdi-account-circle </v-icon>
							مرحبا, {{ activeUser.userName }}
						</v-btn>
				
						<!-- change course -->
						<v-btn
							v-if="config.useCourses && activeCourse"
							height="26"
							text
							small
							color
							class="primary--text font-weight-regular justify-start"
							@click="$emit('change-course')"
						>
							<v-icon left>mdi-school</v-icon>
							{{ activeCourse }}
						</v-btn>
					</div>
				
					<v-spacer/>
				
					<!-- chat -->
					<v-btn
						icon
						color="grey darken-3"
						:to="{ name: 'chat' }"
					>
						<v-icon>mdi-chat-processing</v-icon>
					</v-btn>
				
					<!-- notifications -->
					<v-btn
						v-if="showNotificationBtn"
						icon
						color="grey darken-3"
						@click="checkNotification">
						<v-icon>mdi-bell-ring</v-icon>
					</v-btn>
				</div>
			</template>

			<div class="d-flex align-center mt-2 mb-1">
				<!-- logo -->
				<v-card
					:to="{ name: 'about' }"
					outlined
					rounded="lg"
					class="d-inline-block"
				>
					<v-card-text class="pa-1">
						<v-img
							src="@/assets/Logo.png"
							:height="config.useCourses ? '4rem' : '3.5rem'"
							:max-width="config.useCourses ? '4rem' : '3.5rem'"
							alt="logo"
							contain
						/>
					</v-card-text>
				</v-card>

				<!-- text -->
				<v-list-item class="ps-2 pe-0">
					<v-list-item-content class="py-0">
						<v-list-item-subtitle class="grey--text ps-1 mb-0">مرحباً</v-list-item-subtitle>
						<!-- user -->
						<v-list-item-title class="mb-0">
							<!-- change user -->
							<v-btn
								:ripple="false"
								text
								height="24"
								small
								width="100%"
								class="justify-start text-body-1 font-weight-bold ps-1 pe-0"
								@click="loginMenu = !$isOffline.value"
							>
								{{ activeUser.userName }}
							</v-btn>
						</v-list-item-title>

						<!-- class -->
						<v-list-item-subtitle v-if="config.useCourses && activeCourse">
							<!-- change course -->
							<v-btn
								:ripple="false"
								text
								height="22"
								small
								width="100%"
								color="primary"
								class="justify-start font-weight-regular ps-1 pe-0"
								@click="$emit('change-course')"
							>
								{{ activeCourse }}
							</v-btn>
						</v-list-item-subtitle>
					</v-list-item-content>

					<!-- chat -->
					<v-list-item-action class="ms-2">
						<v-btn
							icon
							color="grey darken-3"
							:to="{ name: 'chat' }"
						>
							<v-icon>mdi-chat-processing</v-icon>
						</v-btn>
					</v-list-item-action>

					<!-- notifications -->
					<v-list-item-action class="ms-0">
						<v-btn
							v-if="showNotificationBtn"
							icon
							color="grey darken-3"
							@click="checkNotification">
							<v-icon>mdi-bell-ring</v-icon>
						</v-btn>
					</v-list-item-action>
				</v-list-item>
			</div>
			<v-divider class="mb-2"/>

			<!-- cards -->
			<div v-if="!isColored" class="mx-auto" style="max-width: 500px">
				<!-- exams card -->
				<v-card
					:to="{ name: 'exams' }"
					class="right-border big-card px-5 py-3 mb-2"
					rounded="lg"
					elevation="3"
				>
					<div v-if="lastExam" class="card-title homeOrange--text">
						<span>المذاكرات</span>
						<v-icon color="homeOrange" size="24">ico-list</v-icon>
					</div>

					<div
						v-if="lastExam && diffDate(new Date(lastExam.Date)) >= 0"
						class="d-flex justify-space-between align-end"
					>
						<div>
							<div class="text-caption primary--text">
								<v-icon color="primary" x-small>mdi-chevron-double-left</v-icon>
								المذاكرة القادمة
								<v-icon color="primary" x-small>mdi-chevron-double-left</v-icon>
							</div>
							<div class="text-h4">
								{{ lastExam.SubjectName }}
							</div>
							<div class="mb-2">
								{{ lastExam.Details }}
							</div>
							<div class="d-flex text-caption">
								<div class="ml-1">
									<v-icon
										color="homeOrange"
										small
									>mdi-calendar-month</v-icon>
									{{ dateFormater(new Date(lastExam.Date)) }}
								</div>
								<div class="ms-3">
									<v-icon
										class="ml-1"
										color="homeOrange"
										small
									>mdi-clock</v-icon
									>{{ getTime(new Date(lastExam.StartTime)) }}
									-
									{{ getTime(new Date(lastExam.EndTime)) }}
								</div>
							</div>
						</div>
						<div class="text-center py-3 homeOrange--text">
							<div class="text-h4">
								{{ diffDate(new Date(lastExam.Date)) }}
							</div>
							<div>أيام متبقية</div>
						</div>
					</div>
					<div
						v-else
						class="d-flex flex-column align-center my-3"
					>
						<v-icon size="32" color="homeOrange" class="mb-2">ico-list</v-icon>
						<span class="text-h6 homeOrange--text">المذاكرات</span>
					</div>
				</v-card>

				<v-row no-gutters class="align-stretch mb-2">
					<!-- Statistics card -->
					<v-col cols="6">
						<v-card
							height="100%"
							:to="{ name: 'statistics' }"
							class="top-border big-card pa-3 me-2"
							rounded="lg"
							elevation="3"
						>
							<div
								v-if="
									(statistics?.MonthlyAverage || statistics?.CountOfTotalMark) &&
									statistics?.MonthlyAverage !== ' - ' ||
									statistics?.CountOfTotalMark !== ' - '
								"
							>
								<div class="card-title homePink--text my-1">
									<span
										style="
											font-size: 1.2rem;
											display: inline-block;
											min-width: max-content;
										"
									>
										الإحصائيات
									</span>
									<v-icon size="22" color="homePink" class="mb-2">ico-chart</v-icon>
								</div>
								<div>
									<span
										v-if="statistics?.MonthlyAverage"
										style="font-size: 2.4rem; line-height: 1"
										class="primary--text font-weight-bold">
										{{ statistics?.MonthlyAverage }}
									</span>
									<span
										v-else
										class="text-h5">
										-
									</span>
								</div>
								<div class="mb-4">عن شهر {{ getMonth(new Date(statistics.Month)) }}</div>
								<div>
									<span class="primary--text text-h4 font-weight-bold">
										{{ statistics?.CountOfTotalMark || 0 }}
									</span>
									<span> علامات تامة</span>
								</div>
								<!-- <div
									class="mt-1"
									v-if="statistics?.SpecialtyRank <= 10">
									ترتيب
									<span class="primary--text text-h4 font-weight-bold">
										{{ statistics?.SpecialtyRank || '-' }}
									</span>
									<span> على الصف</span>
								</div> -->
							</div>
							<div v-else class="d-flex flex-column justify-center align-center fill-height">
								<v-icon size="32" color="homePink" class="mb-2">ico-chart</v-icon>
								<span class="text-h6 homePink--text">الإحصائيات</span>
							</div>
						</v-card>
					</v-col>

					<v-col cols="6">
						<!-- grades card -->
						<v-card
							:to="{ name: 'grades' }"
							height="80"
							class="d-flex align-center right-border big-card px-4 py-0"
							rounded="lg"
							elevation="3"
						>
							<div class="flex-grow-1">
								<div v-if="lastMark">
									<div class="card-title homeYellow--text">
										<span>العلامات</span>
										<v-icon color="homeYellow" size="24">ico-exam</v-icon>
									</div>
									<div>
										<div v-if="!lastMark.IsAbsent" class="mt-n3 mb-n1">
											<span class="primary--text text-h4 font-weight-bold">
												{{ lastMark.Mark }}</span
											>
											\
											<span>{{ lastMark.TestMaxMark }}</span>
										</div>
										<span v-else class="primary--text text-h5 font-weight-bold">
											لم يقدم
										</span>
										<span>{{ lastMark.Test?.SubjectName }}</span>
									</div>
								</div>
								<div v-else class="fill-height d-flex justify-center align-center">
									<span class="text-h6 homeYellow--text me-3">العلامات</span>
									<v-icon color="homeYellow" size="32">ico-exam</v-icon>
								</div>
							</div>
						</v-card>

						<!-- attendance card -->
						<v-card
							:to="{ name: 'attendance' }"
							height="80"
							class="d-flex align-center right-border big-card mt-2 px-4 py-0"
							rounded="lg"
							elevation="3"
						>
							<div class="flex-grow-1">
								<div v-if="attendance.StudentRate">
									<div class="card-title homeBlue--text">
										<span>الحضور</span>
										<v-icon size="22" color="homeBlue">ico-skill-user</v-icon>
									</div>
									<div v-if="attendance.StudentRate" class="mt-n3">
										<span class="primary--text text-h4 font-weight-bold">{{
											attendance.StudentRate
										}}</span>
										\
										<span>{{ attendance.TotalRate }}</span>
									</div>
									<span
										v-else
										class="text-h5">
										-
									</span>
								</div>
								<div v-else class="fill-height d-flex justify-center align-center">
									<span class="text-h6 homeBlue--text me-3">الحضور</span>
									<v-icon color="homeBlue" size="32">ico-skill-user</v-icon>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<v-row dense>
					<!-- Schedule card -->
					<v-col
						:cols="
							config.showSchoolDay && config.showHomeworks
								? 3
								: (config.showSchoolDay || config.showHomeworks ? 4 : 6)
						"
					>
						<v-card
							:to="{ name: 'schedule' }"
							height="100"
							class="d-flex flex-column justify-center align-center top-border"
							rounded="lg"
							elevation="3"
						>
							<v-icon color="homeCyan" size="28">ico-calendar</v-icon>
							<div class="homeCyan--text mt-3">برنامج الدوام</div>
						</v-card>
					</v-col>

					<!-- school day card -->
					<v-col v-if="config.showSchoolDay" :cols="!config.showHomeworks ? 4 : 3">
						<v-card
							:to="{ name: 'school-day' }"
							height="100"
							class="d-flex flex-column justify-center align-center top-border"
							rounded="lg"
							elevation="3"
						>
							<v-icon color="homeCyan" size="28">ico-book-open</v-icon>
							<div class="homeCyan--text mt-3">اليوم الدراسي</div>
						</v-card>
					</v-col>
					
					<!-- homework card -->
					<v-col v-if="config.showHomeworks" :cols="!config.showSchoolDay ? 4 : 3">
						<v-card
							:to="{ name: 'homework' }"
							height="100"
							class="d-flex flex-column justify-center align-center top-border"
							rounded="lg"
							elevation="3"
						>
							<v-icon color="homeCyan" size="28">ico-copybook</v-icon>
							<div class="homeCyan--text mt-3">الواجبات</div>
						</v-card>
					</v-col>

					<!-- behavior notes card -->
					<v-col
						:cols="
							config.showSchoolDay && config.showHomeworks
								? 3
								: (config.showSchoolDay || config.showHomeworks ? 4 : 6)
						"
					>
						<v-card
							:to="{ name: 'behavior' }"
							height="100"
							class="d-flex flex-column justify-center align-center top-border"
							rounded="lg"
							elevation="3"
						>
							<v-icon color="homeCyan" size="28">ico-notes</v-icon>
							<div
								class="homeCyan--text mt-3 text-center"
								v-bind="
									config.showSchoolDay && config.showHomeworks
										? { class: 'mb-n2', style: 'line-height: 16px' }
										: {}
								"
							>الملاحظات السلوكية</div>
						</v-card>
					</v-col>

					<!-- funds card -->
					<v-col v-if="config.showFunds" :cols="config.showBuses ? 6 : 12">
						<v-card
							:to="{ name: 'funds' }"
							height="90"
							class="d-flex align-center right-border big-card px-4 py-0"
							rounded="lg"
							elevation="3"
						>
							<div class="flex-grow-1">
								<div v-if="latestFund">
									<div class="card-title error--text text--darken-2">
										<span>الدفعات</span>
										<v-icon color="error darken-2" size="24">ico-coins</v-icon>
									</div>
									<div>
										<div
											class="text-h5 font-weight-bold mt-n2 mb-n1"
											:class="`${latestFund.InAmount ? 'green' : 'red'}--text text--darken-1`"
										>
											{{(latestFund.OutAmount || latestFund.InAmount || 0).toLocaleString()}}
										</div>
										<span>{{latestFund.InAmount ? 'آخر دفعة' : 'آخر دفعة مستحقة'}}</span>
									</div>
								</div>
								<div v-else class="fill-height d-flex justify-center align-center">
									<span class="text-h6 error--text text--darken-2 me-3">الدفعات</span>
									<v-icon color="error darken-2" size="32">ico-coins</v-icon>
								</div>
							</div>
						</v-card>
					</v-col>

					<!-- buses card -->
					<v-col v-if="config.showBuses" :cols="config.showFunds ? 6 : 12">
						<v-card
							:to="{ name: 'bus' }"
							height="90"
							class="d-flex align-center right-border big-card px-4 py-0"
							rounded="lg"
							elevation="3"
						>
							<div class="flex-grow-1">
								<div v-if="busInfo">
									<div class="card-title success--text text--darken-1">
										<span>المواصلات</span>
										<v-icon color="success darken-1" size="24">ico-bus</v-icon>
									</div>
									<div dir="ltr" class="text-end mt-n2 mb-n1">
										<span class="text-h4 font-weight-bold ms-n1">
											{{moment.utc(busInfo.ArrivalTime).format('hh:mm')}}
										</span>
										<span>{{moment.utc(busInfo.ArrivalTime).locale('en').format('A')}}</span>
									</div>
								</div>
								<div v-else class="fill-height d-flex justify-center align-center">
									<span class="text-h6 success--text text--darken-1 me-3">المواصلات</span>
									<v-icon color="success darken-1" size="32">ico-bus</v-icon>
								</div>
							</div>
						</v-card>
					</v-col>

					<!-- languages -->
					<v-col v-if="config.showLanguages" cols="12">
						<v-card
							:to="{ name: 'languages' }"
							height="80"
							class="d-flex align-center right-border big-card px-4 py-0"
							rounded="lg"
							elevation="3"
						>
							<div class="flex-grow-1">
								<div class="fill-height d-flex justify-center align-center">
									<span class="text-h6 homeBlue--text me-3">اللغات</span>
									<v-icon color="homeBlue" size="32">mdi-web</v-icon>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<!-- colored cards -->
			<v-row v-else dense>
				<!-- homework -->
				<v-col cols="12">
					<v-card
						:to="{ name: 'homework' }"
						width="400"
						height="140"
						class="card-shape myBlue lighten-1 white--text px-4 py-2"
						rounded="lg"
					>
						<!-- shape -->
						<svg
							width="118"
							height="140"
							class="shape myBlue--text"
						>
							<use xlink:href="@/assets/svg/shapes.svg#ico-1"></use>
						</svg>

						<!-- homework -->
						<div v-if="nextHomework" >
							<!-- title -->
							<div class="card-title white--text">
								<span>الواجبات</span>
								<v-icon color="white" size="24">ico-copybook</v-icon>
							</div>
							
							<!-- content -->
							<div class="d-flex justify-space-between align-end">
								<div>
									<div class="text-caption mt-n2 mb-n1">
										<v-icon x-small color="white">mdi-chevron-double-left</v-icon>
											الواجب القادم
										<v-icon x-small color="white">mdi-chevron-double-left</v-icon>
									</div>
									<div class="text-h4">{{ nextHomework.SubjectName }}</div>
									<span class="mb-2">{{ nextHomework.Details }}</span>
									<div class="d-flex text-caption">
										<div>
											<v-icon color="white" small>mdi-calendar-month</v-icon>
											{{ moment.utc(nextHomework.DateTime).format('DD/MM/YYYY') }}
										</div>
										<div class="ms-3">
											<v-icon class="me-1" color="white" small>mdi-clock</v-icon>
											{{ moment.utc(nextHomework.DateTime).format('h a') }}
										</div>
									</div>
								</div>
								<div class="text-center white--text py-3 me-6">
									<div class="text-h4">
										{{moment.utc(nextHomework.ExpectedDate).diff(moment(), 'days')}}
									</div>
									<div>أيام متبقية</div>
								</div>
							</div>
						</div>
						<div
							v-else
							class="d-flex justify-space-between align-center fill-height"
						>
							<span class="text-h5 white--text ms-16">الواجبات</span>
							<v-icon size="32" color="white" class="me-6">ico-copybook</v-icon>
						</div>
					</v-card>
				</v-col>

				<!-- transport & schedule & attendance -->
				<v-col cols="12">
					<v-row dense>
						<!-- transport -->
						<v-col v-if="config.showBuses" cols="6">
							<v-card
								:to="{ name: 'bus' }"
								height="160"
								rounded="lg"
								class="card-shape pa-4 homeDarkPink lighten-1 white--text"
							>
								<!-- shape -->
								<svg
									width="84"
									height="80"
									class="shape homeDarkPink--text"
								>
									<use xlink:href="@/assets/svg/shapes.svg#ico-2"></use>
								</svg>

								<!-- title -->
								<div class="card-title mb-1">
									<span>
										<template v-if="busInfo">
											المواصلات
										</template>
									</span>
									<v-icon size="22" color="white" class="mb-2">ico-bus</v-icon>
								</div>
								
								<!-- content -->
								<div v-if="busInfo">
									<div dir="ltr" class="text-end mt-n2">
										<span class="text-h4 font-weight-bold ms-n1">
											{{moment.utc(busInfo.ArrivalTime).format('hh:mm')}}
										</span>
										<span>{{moment.utc(busInfo.ArrivalTime).locale('en').format('a')}}</span>
										<div class="text-caption">موعد الباص</div>
									</div>
									<div class="mt-4">
										<v-chip
											v-if="busInfo.AssistantPhone"
											color="homeDarkPink white--text ps-0"
											@click.prevent="callPhone(busInfo.AssistantPhone)"
										>
											<div
												class="d-flex justify-center align-center rounded-circle homeDarkPink lighten-2 me-2"
												style="width: 30px; height: 30px"
											>
												<div
													class="d-flex justify-center align-center rounded-circle homeDarkPink"
													style="width: 22px; height: 22px"
												>
													<v-icon size="12">
														mdi-phone mdi-rotate-270
													</v-icon>
												</div>
											</div>
											إجراء اتصال
										</v-chip>
									</div>
								</div>
								<div
									v-else
									class="d-flex flex-column justify-center align-center fill-height mt-n8"
								>
									<span class="text-h6">المواصلات</span>
								</div>
							</v-card>
						</v-col>

						<!-- schedule & attendance -->
						<v-col
							:cols="config.showBuses ? 6 : 12"
							class="d-flex flex-column"
						>
							<v-row dense>
								<!-- schedule -->
								<v-col :cols="config.showBuses ? 12 : 6">
									<v-card
										:to="{ name: 'schedule' }"
										height="76"
										rounded="lg"
										class="card-shape px-4 py-2 homeYellow lighten-1 white--text"
									>
										<!-- shape -->
										<svg
											width="72"
											height="76"
											class="shape homeYellow--text"
											style="top: -8px; left: -6px"
										>
											<use xlink:href="@/assets/svg/shapes.svg#ico-3"></use>
										</svg>

										<!-- title -->
										<div class="card-title mb-1">
											<span>برنامج الدوام</span>
											<v-icon size="22" color="white" class="mt-2">ico-calendar</v-icon>
										</div>

										<!-- content -->
										<div class="mt-n2">
											<span class="text-h4 font-weight-bold me-n1">
												{{moment().format('DD')}}
											</span>
											<span class="text-body-2">{{moment().format('MMMM, YYYY')}}</span>
										</div>
									</v-card>
								</v-col>
								
								<!-- attendance -->
								<v-col :cols="config.showBuses ? 12 : 6">
									<v-card
										:to="{ name: 'attendance' }"
										height="76"
										rounded="lg"
										class="card-shape px-4 py-2 homeOrange lighten-1 white--text"
									>
										<!-- shape -->
										<svg
											width="62"
											height="60"
											class="shape homeOrange--text"
										>
											<use xlink:href="@/assets/svg/shapes.svg#ico-4"></use>
										</svg>

										<!-- title -->
										<div class="card-title mb-1">
											<span>
												<template v-if="attendance.StudentRate">
													الحضور
												</template>
											</span>
											<v-icon size="22" color="white" class="mt-2">ico-skill-user</v-icon>
										</div>

										<!-- content -->
										<div v-if="attendance.StudentRate" class="mt-n3">
											<span class="text-h4 font-weight-bold me-n1">
												{{attendance.StudentRate}}
											</span>
											\
											<span>{{ attendance.TotalRate }}</span>
										</div>
										<div
											v-else
											class="d-flex flex-column justify-center align-center fill-height mt-n9 ms-n10"
										>
											<span class="text-h6">الحضور</span>
										</div>
									</v-card>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>

				<!-- grades & exams & notes -->
				<v-col cols="12">
					<v-row dense>
						<!-- school day -->
						<v-col v-if="config.showSchoolDay" :cols="!config.showSchoolDay ? 4 : 3">
							<v-card
								:to="{ name: 'school-day' }"
								:height="!config.showSchoolDay ? 110 : 100"
								rounded="lg"
								class="d-flex align-center card-shape homePurple lighten-1"
							>
								<!-- shape -->
								<svg
									width="100%"
									:height="!config.showSchoolDay ? 76 : 68"
									class="shape shape--top homePurple--text"
								>
									<use xlink:href="@/assets/svg/shapes.svg#ico-7"></use>
								</svg>

								<!-- title -->
								<div class="d-flex flex-column flex-grow-1 white--text">
									<v-icon size="28" color="white" class="mt-2 mb-4">ico-book-open</v-icon>
									<span class="text-h6 text-center" style="line-height: 20px">
										اليوم الدراسي
									</span>
								</div>
							</v-card>
						</v-col>

						<!-- grades -->
						<v-col :cols="!config.showSchoolDay ? 4 : 3">
							<v-card
								:to="{ name: 'grades' }"
								:height="!config.showSchoolDay ? 110 : 100"
								rounded="lg"
								class="d-flex align-center card-shape homePurple lighten-1"
							>
								<!-- shape -->
								<svg
									width="100%"
									height="74"
									class="shape shape--top homePurple--text"
								>
									<use xlink:href="@/assets/svg/shapes.svg#ico-5"></use>
								</svg>

								<!-- title -->
								<div class="d-flex flex-column flex-grow-1 white--text">
									<v-icon size="28" color="white" class="mt-2 mb-4">ico-exam</v-icon>
									<span class="text-h6 text-center">العلامات</span>
								</div>
							</v-card>
						</v-col>

						<!-- exams -->
						<v-col :cols="!config.showSchoolDay ? 4 : 3">
							<v-card
								:to="{ name: 'exams' }"
								:height="!config.showSchoolDay ? 110 : 100"
								rounded="lg"
								class="d-flex align-center card-shape homePurple lighten-1"
							>
								<!-- shape -->
								<svg
									width="100%"
									height="74"
									class="shape shape--top homePurple--text"
									:style="{ top: '-12px', right: '-10px' }"
								>
									<use xlink:href="@/assets/svg/shapes.svg#ico-6"></use>
								</svg>

								<!-- title -->
								<div class="d-flex flex-column flex-grow-1 white--text">
									<v-icon size="28" color="white" class="mt-2 mb-4">ico-list</v-icon>
									<span class="text-h6 text-center">المذاكرات</span>
								</div>
							</v-card>
						</v-col>

						<!-- behavior -->
						<v-col :cols="!config.showSchoolDay ? 4 : 3">
							<v-card
								:to="{ name: 'behavior' }"
								:height="!config.showSchoolDay ? 110 : 100"
								rounded="lg"
								class="d-flex align-center card-shape homePurple lighten-1"
							>
								<!-- shape -->
								<svg
									width="100%"
									:height="!config.showSchoolDay ? 76 : 68"
									class="shape shape--top homePurple--text"
								>
									<use xlink:href="@/assets/svg/shapes.svg#ico-7"></use>
								</svg>

								<!-- title -->
								<div class="d-flex flex-column flex-grow-1 white--text">
									<v-icon size="28" color="white" class="mt-2 mb-4">ico-notes</v-icon>
									<span class="text-h6 text-center" style="line-height: 20px">
										الملاحظات السلوكية
									</span>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-col>

				<!-- funds & statistics -->
				<v-col cols="12">
					<v-row dense>
						<!-- funds -->
						<v-col v-if="config.showFunds" cols="6">
							<v-card
								:to="{ name: 'funds' }"
								height="90"
								class="card-shape white--text pa-3"
								color="homeBlue lighten-1"
								rounded="lg"
							>
								<!-- shape -->
								<svg
									width="74"
									height="70"
									class="shape homeBlue--text"
									style="top: -4px;"
								>
									<use xlink:href="@/assets/svg/shapes.svg#ico-8"></use>
								</svg>
								
								<div class="card-title">
									<span>
										<template v-if="latestFund">الدفعات</template>
									</span>
									<v-icon color="white" size="24" :class="{ 'me-1': !latestFund }">ico-coins</v-icon>
								</div>

								<!-- content -->
								<div class="flex-grow-1">
									<div v-if="latestFund">
										<div>
											<div class="text-h5 font-weight-bold mt-n2 mb-n1 white--text">
												{{(latestFund.OutAmount || latestFund.InAmount || 0).toLocaleString()}}
											</div>
											<span>{{latestFund.InAmount ? 'آخر دفعة' : 'آخر دفعة مستحقة'}}</span>
										</div>
									</div>
									<div v-else class="fill-height d-flex justify-center align-center">
										<span class="text-h6 mt-n1 ms-n6">الدفعات</span>
									</div>
								</div>
							</v-card>
						</v-col>

						<!-- statistics -->
						<v-col cols="6">
							<v-card
								:to="{ name: 'statistics' }"
								height="90"
								class="card-shape white--text pa-3"
								color="myGreen lighten-1"
								rounded="lg"
							>
								<!-- shape -->
								<svg
									width="60"
									height="60"
									class="shape myGreen--text"
								>
									<use xlink:href="@/assets/svg/shapes.svg#ico-9"></use>
								</svg>

								<div class="card-title">
									<span>
										<template v-if="statistics && statistics?.MonthlyAverage !== ' - '">
											الإحصائيات
										</template>
									</span>
									<v-icon
										color="white"
										size="24"
										:class="{ 'ms-2 mt-2': !statistics }"
									>ico-chart</v-icon>
								</div>

								<!-- content -->
								<div class="flex-grow-1">
									<div
										v-if="statistics && statistics?.MonthlyAverage !== ' - '"
										class="mt-n2"
									>
										<div
											v-if="statistics?.MonthlyAverage"
											class="text-h5 font-weight-bold"
										>
											{{ statistics?.MonthlyAverage }}
										</div>
										<div class="mt-n2 text-body-2">
											معدل {{ moment(statistics.Month).format('MMMM') }}
										</div>
									</div>
									<div v-else class="fill-height d-flex justify-center align-center">
										<span class="text-h6 mt-n1 ms-n6">الإحصائيات</span>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-col>

				<!-- languages -->
				<v-col v-if="config.showLanguages" cols="12">
					<v-card
						:to="{ name: 'languages' }"
						height="76"
						rounded="lg"
						class="card-shape px-4 py-2 homeOrange lighten-1 white--text"
					>
						<!-- shape -->
						<svg
							width="62"
							height="60"
							class="shape homeOrange--text"
						>
							<use xlink:href="@/assets/svg/shapes.svg#ico-4"></use>
						</svg>

						<!-- title -->
						<div class="card-title mb-1">
							<span></span>
							<v-icon size="22" color="white" class="mt-2">mdi-web</v-icon>
						</div>

						<!-- content -->
						<div class="d-flex flex-column justify-center align-center fill-height mt-n9 ms-n10">
							<span class="text-h6">اللغات</span>
						</div>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<v-footer app class="justify-center footer transparent pb-1">
			<div class="d-flex align-center justify-space-between page-container px-2">
				v{{ version.version }}
				<a
					href="https://edunix.beetronix.net"
					target="_blank">
					<v-img
						href=""
						src="@/assets/edunix-logo-text.png"
						contain
						height="3rem"
						width="6rem"
					/>
				</a>
				<!-- <div class="footer-image">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 650 215"
						style="
							shape-rendering: geometricPrecision;
							text-rendering: geometricPrecision;
							image-rendering: optimizeQuality;
							fill-rule: evenodd;
							clip-rule: evenodd;
						"
						xmlns:xlink="http://www.w3.org/1999/xlink">
						<g>
							<path
								d="M 108.5,-0.5 C 137.167,-0.5 165.833,-0.5 194.5,-0.5C 270.014,2.8347 343.681,16.668 415.5,41C 495.13,70.3827 563.963,115.883 622,177.5C 632.458,189.444 642.291,201.778 651.5,214.5C 651.5,214.833 651.5,215.167 651.5,215.5C 434.167,215.5 216.833,215.5 -0.5,215.5C -0.5,147.5 -0.5,79.5 -0.5,11.5C 35.7793,5.70683 72.1126,1.70683 108.5,-0.5 Z" />
						</g>
					</svg>
				</div> -->
			</div>
		</v-footer>

		<v-bottom-sheet v-model="loginMenu">
			<v-sheet class="pa-3 rounded-t-lg">
				<v-list>
					<v-list-item
						v-for="user in users"
						:key="user.userName">
						<v-list-item-content @click="login(user)">
							<v-list-item-title>
								{{ user.userName }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-icon
							@click="
								openLogoutDialog = true;
								userToLogout = user;
							">
							<v-icon color="myOrange"> mdi-logout </v-icon>
						</v-list-item-icon>
					</v-list-item>
				</v-list>
				<div class="d-flex justify-space-between">
					<v-btn
						color="primary"
						text
						@click="loginMenu = false">
						إلغاء
					</v-btn>
					<v-btn
						color="primary"
						:to="{ name: 'login' }">
						اضافة حساب
					</v-btn>
				</div>
			</v-sheet>
		</v-bottom-sheet>

		<v-dialog
			v-model="openLogoutDialog"
			width="400">
			<v-card
				class="pa-6"
				rounded="lg">
				<p class="text-center mb-8 text-h6">هل تريد تسجيل الخروج؟</p>
				<v-row>
					<v-col cols="6">
						<v-btn
							color="primary"
							block
							@click="
								openLogoutDialog = false;
								userToLogout = null;
							">
							إلغاء
						</v-btn>
					</v-col>
					<v-col cols="6">
						<v-btn
							color="primary"
							text
							block
							@click="
								openLogoutDialog = false;
								logout(userToLogout);
							">
							تاكيد
						</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
	</div>
	<!-- </div> -->
</template>

<script>
import Loader from '@/components/Loader.vue';
import { dateFormater, diffDate, getTime, getMonth } from '@/helpers/helpers';
import { mapGetters, mapState } from 'vuex';
import config from '@/helpers/config';
import stores from '@/idb/stores';
import * as idb from 'idb';
import { isNotificationsSupported } from '@/firebase/messaging';
import { fundsType } from '@/helpers/enums';
import moment from '@/moment';

export default {
	name: 'Home',

	components: {
		Loader,
	},

	data() {
		return {
			moment,
			loading: true,
			loginMenu: false,

			openLogoutDialog: false,
			userToLogout: null,

			config,

			showNotificationBtn: false,

			latestFund: null,
			busInfo: null,
			nextHomework: null,
		};
	},

	computed: {
		...mapState({
			activeCourseId: state => state.courses.activeCourseId,
			users: (state) => state.login.users,
			activeUser: (state) => state.login.activeUser,
			attendance: (state) => state.home.attendance,
			statistics: (state) => state.home.statistics,
			lastMark: (state) => state.home.lastMark,
			version: (state) => state.home.version,
			lastExam: (state) => state.exams.lastExam,
		}),
		...mapGetters({
			getCourseById: 'courses/getCourseById'
		}),

		isColored() {
			return this.activeUser ? this.activeUser.colored : false;
		},
		
		activeCourse() {
			return this.getCourseById(this.activeCourseId)?.CourseName || null;
		},
	},

	methods: {
		dateFormater,
		diffDate,
		getTime,
		getMonth,
		resetIDB() {
			const dbPromise = idb.openDB('api-response', 1);
			const clearAll = (storeName) =>
				dbPromise.then((db) => {
					const tx = db.transaction(storeName, 'readwrite');
					tx.store.clear();
					return tx.done;
				});
			const promises = [];
			Object.keys(stores).forEach((storeKey) => {
				promises.push(clearAll(stores[storeKey].name));
			});
			promises.push(clearAll('objects'));
			return Promise.all(promises).catch(() => {});
		},
		login(user) {
			// if try to log to the same user ignor
			if (this.activeUser.userName === user.userName) {
				this.loginMenu = false;
				return;
			}

			this.loading = true;
			this.loginMenu = false;
			this.$store
				.dispatch('login/login', {
					userName: user.userName,
					password: user.password,
				})
				.then(() => {
					this.$store.dispatch('clearAll');
					this.resetIDB();
					this.fetch().finally(() => {
						if (config.useCourses) {
							this.$emit('change-course')
						}
					});
				})
				.catch((err) => {
					if (err.response.status === 401) {
						this.$store.dispatch('login/logout', { user });
						this.$eventBus.$emit('show-snackbar', true, 'تم تعديل معلومات الحساب او حذفه');
						this.$router.push({ name: 'accounts' });
					} else {
						this.$eventBus.$emit('show-snackbar', true, 'حدث خطأ ما. اعد المحاولة لاحقا');
					}
				});
		},
		logout(user) {
			const activeUser = this.activeUser;
			this.$store.dispatch('login/logout', { user });
			this.$eventBus.$emit('show-snackbar', false, 'تم تسجيل الخروج');
			if (user.userName === activeUser.userName) {
				this.$store.dispatch('clearAll');
				this.resetIDB();
				if (this.users.length) this.$router.push({ name: 'accounts' });
				else this.$router.push({ name: 'login' });
			}
			this.userToLogout = null;
			this.loginMenu = false;
		},
		fetch() {
			this.loading = true;
			return Promise.all([
				this.$store.dispatch('home/fetchAttendance'),
				this.$store.dispatch('home/fetchStatistics'),
				this.$store.dispatch('home/fetchLastMark'),
				this.$store.dispatch('home/fetchVersion'),
				this.$store.dispatch('exams/fetchLast'),
				config.showFunds
					? this.$store.dispatch('funds/fetchFunds').then((data) => {
						const funds = data.AllFunds.sort((a, b) => new Date(b.DateTime) - new Date(a.DateTime));
						const latestFundPaid = funds.find((item) => item.FundStatus === fundsType.Paid);
						const latestFundDue = funds.find((item) => item.FundStatus === fundsType.Due);

						if (this.latestFundPaid && this.latestFundDue) {
							this.latestFund =
								moment(latestFundPaid.DateTime).isAfter(moment(latestFundDue.DateTime))
									? latestFundPaid
									: latestFundDue;
						} else {
							this.latestFund = latestFundPaid || latestFundDue || {};
						}
					})
					: null,
				config.showBuses
					? this.$store.dispatch('bus/fetchBusInfo').then((data) => {
						this.busInfo = data;
					})
					: null,
				this.isColored
					? this.$store.dispatch('homeworks/getNextHomeworks', {
						fromDate: moment().format('YYYY-MM-DD'),
						toDate: moment().add(30, 'days').format('YYYY-MM-DD')
					}).then((data) => {
						this.nextHomework = (data.length ? data[0] : null);
					})
					: null
			]).finally(() => {
				this.loading = false;
			});
		},

		checkNotification() {
			Notification.requestPermission().then((result) => {
				if (result === 'granted') {
					this.$router.push({ name: 'notifications' });
				} else {
					alert(
						'الرجاء منح التطبيق سماحية استخدام التنبيهات والتأكد أنك لا تستخدم وضع التصفح المتخفي أو الخاص.',
					);
				}
			});
		},

		callPhone(phone) {
			window.open(`tel:${phone}`, '_self');
		},
	},

	created() {
		isNotificationsSupported().then((supported) => {
			if (supported) {
				this.showNotificationBtn = true;
				this.$store.dispatch('notifications/fetchAll');
			}
		});
	},

	mounted() {
		this.fetch();
	},
};
</script>

<style scoped lang="scss">
$border: 4px solid var(--v-primary-base);
.header-image {
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	max-height: 100px;
	svg {
		width: 100%;
		max-height: 100px;
		fill: var(--v-alt-base);
	}
}
.page-container {
	width: 400px;
	min-width: 250px;
}
.footer-image {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 300px;
	z-index: -1;
	@media (max-width: 576px) {
		width: 250px;
	}
	svg {
		display: block;
		margin-bottom: -2px;
		fill: var(--v-alt-base);
	}
}
.card-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 0.2rem;
	span {
		font-size: 1.5rem;
		font-weight: bold;
	}
}
.card-shape {
	position: relative;
	overflow: hidden;
	z-index: 0;
	.shape {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		&--top {
			top: -10px;
			left: 0;
			right: 0;
		}
	}
	* { z-index: 2; }
}
svg { fill: currentColor; }
.right-border {
	position: relative;
	overflow: hidden;
	padding-right: 20px !important;
	&::before {
		opacity: 1;
		content: '';
		height: 100%;
		width: 10px;
		background-color: var(--v-alt-base);
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
	}
}
.top-border {
	position: relative;
	overflow: hidden;
	padding-top: 10px !important;
	&::before {
		opacity: 1;
		content: '';
		height: 10px;
		width: 100%;
		background-color: var(--v-alt-base);
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
	}
}
</style>
